import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { BudgetClassificationCodeFormComponent } from '@zaoblako/web/modules/admin/dumbs/budget-classification-code-form/budget-classification-code-form.component';
import { ChangelogFormComponent } from '@zaoblako/web/modules/admin/dumbs/changelog-form/changelog-form.component';
import { CurrencyFormComponent } from '@zaoblako/web/modules/admin/dumbs/currency-form/currency-form.component';
import { Extension1cFormComponent } from '@zaoblako/web/modules/admin/dumbs/extension1c-form/extension1c-form.component';
import { PayerStatusFormComponent } from '@zaoblako/web/modules/admin/dumbs/payer-status-form/payer-status-form.component';
import { RatePlanFormComponent } from '@zaoblako/web/modules/admin/dumbs/rate-plan-form/rate-plan-form.component';
import { RevenueAdminFormComponent } from '@zaoblako/web/modules/admin/dumbs/revenue-admin-form/revenue-admin-form.component';
import { BalanceCustomRowFormComponent } from '@zaoblako/web/modules/budget/dumbs/balance-custom-row-form/balance-custom-row-form.component';
import { BudgetTaskFormSidebarComponent } from '@zaoblako/web/modules/budget/dumbs/budget-task-form-sidebar/budget-task-form-sidebar.component';
import { ClientFormComponent } from '@zaoblako/web/modules/client/dumbs/client-form/client-form.component';
import { ContractFormComponent } from '@zaoblako/web/modules/client/dumbs/contract-form/contract-form.component';
import { ContragentFormComponent } from '@zaoblako/web/modules/client/dumbs/contragent-form/contragent-form.component';
import { CompanyFormComponent } from '@zaoblako/web/modules/company/dumbs/company-form/company-form.component';
import { CompanyGroupFormComponent } from '@zaoblako/web/modules/company/dumbs/company-group-form/company-group-form.component';
import { Database1cFormComponent } from '@zaoblako/web/modules/company/dumbs/database1c-form/database1c-form.component';
import { ConverterFormComponent } from '@zaoblako/web/modules/control/dumbs/converter-form/converter-form.component';
import { DealFormSidebarComponent } from '@zaoblako/web/modules/deal/dumbs/deal-form-sidebar/deal-form-sidebar.component';
import { DealGroupFormComponent } from '@zaoblako/web/modules/deal/dumbs/deal-group-form/deal-group-form.component';
import { ExclusionFormComponent } from '@zaoblako/web/modules/debts/dumbs/exclusion-form/exclusion-form.component';
import { NewsletterFormSidebarComponent } from '@zaoblako/web/modules/debts/dumbs/newsletter-form-sidebar/newsletter-form-sidebar.component';
import { NewsletterTemplateFormSidebarComponent } from '@zaoblako/web/modules/debts/dumbs/newsletter-template-form-sidebar/newsletter-template-form-sidebar.component';
import { ApprovalSchemeFormComponent } from '@zaoblako/web/modules/directory/dumbs/approval-scheme-form/approval-scheme-form.component';
import { CostCenterFormComponent } from '@zaoblako/web/modules/directory/dumbs/cost-center-form/cost-center-form.component';
import { DirectionFormComponent } from '@zaoblako/web/modules/directory/dumbs/direction-form/direction-form.component';
import { DirectionGroupFormComponent } from '@zaoblako/web/modules/directory/dumbs/direction-group-form/direction-group-form.component';
import { DocumentTypeFormComponent } from '@zaoblako/web/modules/directory/dumbs/document-type-form/document-type-form.component';
import { FilialFormComponent } from '@zaoblako/web/modules/directory/dumbs/filial-form/filial-form.component';
import { NomenclatureFormComponent } from '@zaoblako/web/modules/directory/dumbs/nomenclature-form/nomenclature-form.component';
import { NomenclatureGroupFormComponent } from '@zaoblako/web/modules/directory/dumbs/nomenclature-group-form/nomenclature-group-form.component';
import { OperationTypeErp1cFormComponent } from '@zaoblako/web/modules/directory/dumbs/operation-type-erp-1c-form/operation-type-erp-1c-form.component';
import { OperationTypeFormComponent } from '@zaoblako/web/modules/directory/dumbs/operation-type-form/operation-type-form.component';
import { ProjectMasterMilestoneFormComponent } from '@zaoblako/web/modules/directory/dumbs/project-master-milestone-form/project-master-milestone-form.component';
import { RoomFormComponent } from '@zaoblako/web/modules/directory/dumbs/room-form/room-form.component';
import { UnitFormComponent } from '@zaoblako/web/modules/directory/dumbs/unit-form/unit-form.component';
import { DocumentFormSidebarComponent } from '@zaoblako/web/modules/document/dumbs/document-form-sidebar/document-form-sidebar.component';
import { DocumentRegulationFormComponent } from '@zaoblako/web/modules/document/dumbs/document-regulation-form/document-regulation-form.component';
import { DocumentSalaryDistributionFormComponent } from '@zaoblako/web/modules/document/dumbs/document-salary-distribution-form/document-salary-distribution-form.component';
import { DocumentTemplateFormComponent } from '@zaoblako/web/modules/document/dumbs/document-template-form/document-template-form.component';
import { HelpdeskAcceptTaskFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-accept-task-form/helpdesk-accept-task-form.component';
import { HelpdeskEavEntityTypeFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-eav-entity-type-form/helpdesk-eav-entity-type-form.component';
import { HelpdeskTaskFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-task-form/helpdesk-task-form.component';
import { HelpdeskTaskTypeFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-task-type-form/helpdesk-task-type-form.component';
import { HelpdeskTemplateFormComponent } from '@zaoblako/web/modules/help-desk/dumbs/helpdesk-template-form/helpdesk-template-form.component';
import { LkEuHelpdeskTaskFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/helpdesk-task-form/lk-eu-helpdesk-task-form.component';
import { LkEuTransitTaskFormComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/transit-task-form/lk-eu-transit-task-form.component';
import { KktFormComponent } from '@zaoblako/web/modules/ofd/dumbs/kkt-form/kkt-form.component';
import { TypeOfActivityFormComponent } from '@zaoblako/web/modules/ofd/dumbs/type-of-activity-form/type-of-activity-form.component';
import { ResidentCarFormComponent } from '@zaoblako/web/modules/passage/dumbs/resident-car-form/resident-car-form.component';
import { TransitTaskFormComponent } from '@zaoblako/web/modules/passage/dumbs/transit-task-form/transit-task-form.component';
import { PaymentStatusFormComponent } from '@zaoblako/web/modules/payments/dumbs/payment-status-form/payment-status-form.component';
import { PlannedIncomeFormComponent } from '@zaoblako/web/modules/payments/dumbs/planned-income-form/planned-income-form.component';
import { TaskFormSidebarComponent } from '@zaoblako/web/modules/payments/dumbs/task-form-sidebar/task-form-sidebar.component';
import { TaskScenarioFormComponent } from '@zaoblako/web/modules/payments/dumbs/task-scenario-form/task-scenario-form.component';
import { TaskTemplateFormComponent } from '@zaoblako/web/modules/payments/dumbs/task-template-form/task-template-form.component';
import { ProjectFormComponent } from '@zaoblako/web/modules/project/dumbs/project-form/project-form.component';
import { ProjectTemplateFormComponent } from '@zaoblako/web/modules/project/dumbs/project-template-form/project-template-form.component';
import { AccessCardFormComponent } from '@zaoblako/web/modules/security/dumbs/access-card-form/access-card-form.component';
import { ExternalUserCreateFormComponent } from '@zaoblako/web/modules/security/dumbs/external-user-create-form/external-user-create-form.component';
import { ExternalUserEditFormComponent } from '@zaoblako/web/modules/security/dumbs/external-user-edit-form/external-user-edit-form.component';
import { RoleFormComponent } from '@zaoblako/web/modules/security/dumbs/role-form/role-form.component';
import { ScheduleFormComponent } from '@zaoblako/web/modules/security/dumbs/schedule-form/schedule-form.component';
import { UserCreateFormComponent } from '@zaoblako/web/modules/security/dumbs/user-create-form/user-create-form.component';
import { UserEditFormComponent } from '@zaoblako/web/modules/security/dumbs/user-edit-form/user-edit-form.component';
import { UserGroupFormComponent } from '@zaoblako/web/modules/security/dumbs/user-group-form/user-group-form.component';
import { TrafficAdapterFormComponent } from '@zaoblako/web/modules/traffic/dumbs/traffic-adapter-form/traffic-adapter-form.component';
import { NetPingDeviceFormComponent } from '@zaoblako/web/modules/control/dumbs/net-ping-device-form/net-ping-device-form.component';
import { HikvisionCameraFormComponent } from '@zaoblako/web/modules/passage/dumbs/hikvision-camera-form/hikvision-camera-form.component';
import { TypeFormEnum } from '@zaoblako/web/shared/components/form-sidebar/enums/type.form.enum';
import { FormType } from '@zaoblako/web/shared/components/form-sidebar/models/form-state';
import { FormStoreService } from '@zaoblako/web/shared/components/form-sidebar/services/form-store.service';
import { SharedModule } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'crm-form-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    BudgetTaskFormSidebarComponent,
    SidebarModule,
    SharedModule,
    CheckboxModule,
    FormsModule,
    RatePlanFormComponent,
    ContragentFormComponent,
    PlannedIncomeFormComponent,
    DirectionFormComponent,
    DirectionGroupFormComponent,
    UnitFormComponent,
    FilialFormComponent,
    DocumentTypeFormComponent,
    OperationTypeFormComponent,
    OperationTypeErp1cFormComponent,
    ProjectMasterMilestoneFormComponent,
    ApprovalSchemeFormComponent,
    TaskFormSidebarComponent,
    Database1cFormComponent,
    CompanyFormComponent,
    CompanyGroupFormComponent,
    ClientFormComponent,
    UserCreateFormComponent,
    UserEditFormComponent,
    UserGroupFormComponent,
    RoleFormComponent,
    ScheduleFormComponent,
    Extension1cFormComponent,
    ChangelogFormComponent,
    DealGroupFormComponent,
    DealFormSidebarComponent,
    ExclusionFormComponent,
    NewsletterFormSidebarComponent,
    NewsletterTemplateFormSidebarComponent,
    HelpdeskTaskFormComponent,
    HelpdeskTemplateFormComponent,
    HelpdeskTaskTypeFormComponent,
    ProjectFormComponent,
    ProjectTemplateFormComponent,
    BalanceCustomRowFormComponent,
    PaymentStatusFormComponent,
    TaskTemplateFormComponent,
    DocumentFormSidebarComponent,
    DocumentTemplateFormComponent,
    DocumentRegulationFormComponent,
    TooltipModule,
    RoomFormComponent,
    ContractFormComponent,
    DocumentSalaryDistributionFormComponent,
    NomenclatureFormComponent,
    NomenclatureGroupFormComponent,
    ConverterFormComponent,
    AccessCardFormComponent,
    KktFormComponent,
    TypeOfActivityFormComponent,
    ExternalUserCreateFormComponent,
    ExternalUserEditFormComponent,
    HelpdeskAcceptTaskFormComponent,
    LkEuHelpdeskTaskFormComponent,
    CostCenterFormComponent,
    TrafficAdapterFormComponent,
    PayerStatusFormComponent,
    BudgetClassificationCodeFormComponent,
    RevenueAdminFormComponent,
    CurrencyFormComponent,
    TaskScenarioFormComponent,
    TransitTaskFormComponent,
    LkEuTransitTaskFormComponent,
    ResidentCarFormComponent,
    HelpdeskEavEntityTypeFormComponent,
    NetPingDeviceFormComponent,
    HikvisionCameraFormComponent
  ],
  templateUrl: './form-sidebar.component.html',
  styleUrls: ['./form-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class FormSidebarComponent implements OnInit {
  public forms$: Observable<FormType[]>;

  public get TypeFormEnum() {
    return TypeFormEnum;
  }

  public constructor(
    private readonly formStoreService: FormStoreService,
    private readonly renderer: Renderer2,
    private readonly route: ActivatedRoute,
    private readonly errorService: ErrorService
  ) {}

  public ngOnInit(): void {
    this.forms$ = this.formStoreService
      .select((state) => state.forms)
      .pipe(
        tap((forms) => {
          forms.forEach((form, index) => {
            if (form.isShowSidebar && form.typeZIndex === 'z-index-2000') {
              setTimeout(() => {
                const mask = document.querySelectorAll('.p-sidebar-mask');
                if (mask[index]) {
                  this.renderer.setStyle(mask[index], 'z-index', 1999, 1);
                }
              });
            }
            if (index && form.isShowSidebar) {
              setTimeout(() => {
                const mask = document.querySelectorAll('.p-sidebar-mask');
                const sidebar = document.querySelectorAll('.p-sidebar');
                if (mask[index]) {
                  this.renderer.setStyle(mask[index], 'z-index', 999 + index * 2, 1);
                }
                if (sidebar[index]) {
                  this.renderer.setStyle(sidebar[index], 'z-index', 1000 + index * 2, 1);
                }
              });
            }
          });
        })
      );
  }

  public closeSidebar(visible: boolean, index: number) {
    if (!visible) {
      this.formStoreService.closeSidebar(index);
    }
  }

  public toggleIsRedirectInCreate(value: boolean, index: number) {
    this.formStoreService.toggleIsRedirectInCreate(value, index);
  }

  public shareLinkForm(index: number) {
    let params: HttpParams = new HttpParams();
    Object.keys(this.route.snapshot.queryParams).forEach((key) => {
      params = params.append(key, this.route.snapshot.queryParams[key]);
    });
    params = params.append('formType', this.formStoreService.getState.forms[index].type);
    params = params.append('formId', this.formStoreService.getState.forms[index].entityId);
    params = params.append('formHeaderText', this.formStoreService.getState.forms[index].headerText);
    params = params.append('formWidthSize', this.formStoreService.getState.forms[index].widthSize);
    params = params.append('formIsShowDelete', this.formStoreService.getState.forms[index].isShowDelete);
    params = params.append('formIsShowShare', this.formStoreService.getState.forms[index].isShowShare);
    params = params.append('formTypeZIndex', this.formStoreService.getState.forms[index].typeZIndex);
    const url = window.location.origin + window.location.pathname + '?' + params.toString();
    navigator.clipboard
      .writeText(url)
      .then(() => {
        this.errorService.addSuccessMessage('Ссылка скопирована');
      })
      .catch(console.error);
  }
}
